import axios from 'axios';

import BaseService from './BaseService';
import Configuration from './ServiceConfig';
import { Language } from '../interfaces/Language';

class LanguageService extends BaseService {
	config: Configuration;
	path: string;
	token: string | null;

	constructor() {
		super();
		this.config = new Configuration();
		this.path = `${this.config.baseurl}${'languages/'}`;
		this.token = localStorage.getItem('token');
	}

	async getLanguages(): Promise<Language[]> {
		return axios
			.get(`${this.path}`, {
				headers: {
					Authorization: `Bearer ${this.token}`,
				},
			})
			.then(response => {
				return response.data;
			})
			.catch(err => {
				if (err.response) {
					this.handleResponseError(err.response);
				} else {
					this.handleError(err);
				}
			});
	}
}

export default LanguageService;
